/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSubEvaluationRatingInput } from './oralExamSubEvaluationRatingInput';

export type OralExamTaskEvaluationInputSubEvaluations = { [key: string]: OralExamSubEvaluationRatingInput };
